/**
 * Age Verification Popup
 * Shows once per browser (based on cookie expiry set in theme editor),
 * never re-displays until the cookie expires or is cleared.
 */
(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function init() {
    var popup = document.getElementById('age-verification-popup');
    if (!popup) return;

    var cookieName = popup.getAttribute('data-cookie-name') || 'age_verified';
    var cookieDays = parseInt(popup.getAttribute('data-cookie-days'), 10) || 30;
    var denyUrl = popup.getAttribute('data-deny-url') || 'https://www.google.com';

    var alreadyVerified = getCookie(cookieName) === 'true';

    if (alreadyVerified) {
      // Already verified — do nothing, popup stays hidden.
      return;
    }

    // Show the popup
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('age-verification-locked');

    var confirmBtn = document.getElementById('age-verification-confirm');
    var denyBtn = document.getElementById('age-verification-deny');

    function closePopup() {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('age-verification-locked');
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        setCookie(cookieName, 'true', cookieDays);
        closePopup();
      });
    }

    if (denyBtn) {
      denyBtn.addEventListener('click', function () {
        window.location.href = denyUrl;
      });
    }

    // Trap focus within modal for accessibility while open
    popup.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        // Do not allow closing via escape without confirming age,
        // since this is a legal gate, not a dismissible banner.
        e.preventDefault();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
